import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectQueryFilters = (store: StoreSchema) => store.instanceEvents.queryFilter
export const selectUpdateTimeFrom = (store: StoreSchema) => store.instanceEvents.filter.updateTimeFrom
export const selectUpdateTimeTo = (store: StoreSchema) => store.instanceEvents.filter.updateTimeTo